import React, { useState } from 'react'
import Modal from "react-bootstrap/Modal";
import { Link } from 'react-router-dom';
function UserMenuComp() {
    const [addMenuModal, setAddMenuModal] = useState(false);
    const [menu, setMenu] = useState("")
    function ModalClose() {
        setAddMenuModal(false)
    }
    return (
        <>
            <div className="page-header">
                <h1><button onClick={() => setAddMenuModal(!addMenuModal)} className="btn_5 mr10 float-end" >Add Menu</button>
                    Menus</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                    <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Menus Listing
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="row mb30">
                    <div className="col-md-12">
                        <table className="table_style_1">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>Menu</th>
                                    <th>Sub Menu</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Home</td>
                                    <td></td>
                                    <td>Active</td>
                                    <td>
                                        <button className="btn_7 mr03">Edit</button>
                                        <button className="btn_8">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addmenu" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <Modal show={addMenuModal} size="md" id="confirm_login">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="float-end btn_close" onClick={ModalClose} aria-label="Close">
                                <i className="icon icon-cross"></i>
                            </button>
                            <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Add Menus</div>
                            <form>
                                <div className="mb-2">
                                    <label className="col-form-label">Menu Name</label>
                                    <input type="text"  value={menu} onChange={(e)=>setMenu(e.target.value)} className="form-control" />
                                </div>
                                <div className="mb-2">
                                    <label className="col-form-label">Sub Menu Name</label>
                                    <input type="text" className="form-control" />
                                </div>
                                <div className="mb-2">
                                    <label className="col-form-label">Status</label>
                                    <div className="">
                                        <div className="form-check d-inline-block hand">
                                            <input className="form-check-input" type="radio" name="radio" id="active" />
                                            <label className="form-check-label" htmlFor="active">
                                                Active
                                            </label>
                                        </div>
                                        <div className="form-check d-inline-block hand ml20">
                                            <input className="form-check-input" type="radio" name="radio" id="inactive" checked />
                                            <label className="form-check-label" htmlFor="inactive">
                                                Inactive
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="modalfooter">
                                <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" onClick={ModalClose}>Cancel</button>
                                <button type="button" className="btn_5 float-end ">Submit</button>
                            </div>
                        </div>

                    </div>
                </Modal>

            </div>
        </>
    )
}

export default UserMenuComp
